// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__1un6i","selected":"styles_selected__19Xv_"};